import React from 'react';
import ReactDOM from 'react-dom';
import './config.js'
import './index.css';
import App from './App';
//import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from "react-router-dom";
import ErrorBoundary from "./components/Utility/ErrorBoundary"
import AuthProvider from "./components/Contexts/AuthContext"

ReactDOM.render(
		<ErrorBoundary>
			<AuthProvider>
				<Router>
					<App />
				</Router>
			</AuthProvider>
		</ErrorBoundary>, 
	document.getElementById("root"));

/*

const rootElement = document.getElementById("root");
if (rootElement.hasChildNodes()) {
	ReactDOM.hydrate(
		<React.Fragment>
		<Preloader/>
		<Router>
			<App />
		</Router>
		</React.Fragment>, rootElement);
} else {
	ReactDOM.render(
		<React.Fragment>
		<Preloader/>
		<Router>
			<App />
		</Router>
		</React.Fragment>, rootElement);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
*/